export var extractWebSolutions = function (rawCollection) {
    var _a, _b, _c, _d, _e;
    return (_e = (_d = (_c = (_b = (_a = rawCollection === null || rawCollection === void 0 ? void 0 : rawCollection.sectionData) === null || _a === void 0 ? void 0 : _a.tagData) === null || _b === void 0 ? void 0 : _b.tagsToWebSolutions) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.webSolutions) === null || _e === void 0 ? void 0 : _e.webSolutions;
};
export var getWebSolutionData = function (webSolution) {
    var baseInfo = webSolution.baseInfo, assetsMap = webSolution.assetsMap;
    return {
        id: baseInfo.id,
        slug: baseInfo.slug,
        name: baseInfo.name,
        description: baseInfo.teaser,
        teaser: baseInfo.teaser,
        icon: baseInfo.icon,
        appIcon: baseInfo.icon,
        pricing: baseInfo.pricing,
        numberOfReviews: baseInfo.numberOfReviews || 0,
        reviewStars: baseInfo.reviewStars || 0,
        // badge: baseInfo.badge,
        // isInstalled: baseInfo.isInstalled,
        company: baseInfo.company,
        openConsentIn: baseInfo.openConsentIn,
        Tags: baseInfo.Tags,
        type: baseInfo.type,
    };
};
export var getFakeWebSolutionBiData = function (solutions, widgetName) {
    return solutions.map(function (solution, index) {
        return {
            impressionType: widgetName,
            index: index,
            market: 'fake market',
            tagName: 'fake tagName',
            tagType: 'fake tagType',
            subCategory: 'fake subCategory',
        };
    });
};
export var isWixApp = function (companyId) {
    return companyId === 'ad147a73-a40e-4e50-8344-2ad33592790d' || companyId === 'a60ac714-5c5a-4c38-a285-573752f04876';
};
export function getPricingLabel(pricing, shouldShowFullPrices, companyId) {
    var isInAppPurchase = pricing === null || pricing === void 0 ? void 0 : pricing.isInAppPurchase;
    var freeTrialDays = pricing === null || pricing === void 0 ? void 0 : pricing.freeTrialDays;
    if (!shouldShowFullPrices) {
        return pricing === null || pricing === void 0 ? void 0 : pricing.pricingLabel;
    }
    if (isWixApp(companyId)) {
        return 'app.pricing.free-to-install';
    }
    if ((pricing === null || pricing === void 0 ? void 0 : pricing.businessModel) === 'DYNAMIC') {
        return 'app.pricing.freemium-free-to-install';
    }
    if ((pricing === null || pricing === void 0 ? void 0 : pricing.businessModel) === 'FREE') {
        return isInAppPurchase ? 'app.pricing.free-to-install' : 'app.pricing.free';
    }
    if ((pricing === null || pricing === void 0 ? void 0 : pricing.businessModel) === 'FREEMIUM') {
        return isInAppPurchase
            ? 'app.pricing.freemium-free-to-install'
            : 'app.pricing.free-plan-available';
    }
    if ((pricing === null || pricing === void 0 ? void 0 : pricing.businessModel) === 'PREMIUM' && freeTrialDays > 0 && isInAppPurchase) {
        return 'app.pricing.trial-days-in-app';
    }
    if ((pricing === null || pricing === void 0 ? void 0 : pricing.businessModel) === 'PREMIUM' && freeTrialDays > 0 && !isInAppPurchase) {
        return 'app.pricing.trial-days-premium';
    }
    if ((pricing === null || pricing === void 0 ? void 0 : pricing.businessModel) === 'PREMIUM' && freeTrialDays <= 0 && !(pricing === null || pricing === void 0 ? void 0 : pricing.isExternalPricing)) {
        return 'app.pricing.from-in-app-full';
    }
    if ((pricing === null || pricing === void 0 ? void 0 : pricing.businessModel) === 'PREMIUM' && freeTrialDays <= 0 && (pricing === null || pricing === void 0 ? void 0 : pricing.isExternalPricing)) {
        return 'app.pricing.free-to-install';
    }
}
export var getLowestPrice = function (pricing) {
    var _a, _b, _c, _d, _e, _f, _g;
    var pricesWithoutTax = (_c = (_b = (_a = pricing === null || pricing === void 0 ? void 0 : pricing.plans) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.premiumPrices) === null || _c === void 0 ? void 0 : _c.fullPrices.map(function (price) { return Number(price.monthlyPriceBeforeTax); });
    var pricesWithTax = (_f = (_e = (_d = pricing === null || pricing === void 0 ? void 0 : pricing.plans) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.premiumPrices) === null || _f === void 0 ? void 0 : _f.fullPrices.map(function (price) { return Number(price.monthlyPriceWithTax); });
    var lowestPrice = ((_g = pricing === null || pricing === void 0 ? void 0 : pricing.taxSettings) === null || _g === void 0 ? void 0 : _g.showPricesWithTax) ? Math.min.apply(Math, pricesWithTax) : Math.min.apply(Math, pricesWithoutTax);
    return lowestPrice;
};
export var getCollectionDefinition = function (rawTagDefinition) { return ({
    name: rawTagDefinition.name,
    slug: rawTagDefinition.slug,
    description: rawTagDefinition.description,
    type: rawTagDefinition.type,
    // teaser: rawTagDefinition.teaser,
    color: rawTagDefinition.colors[0],
}); };
export var extractTagsDefinition = function (tagsToWebSolutions) {
    return tagsToWebSolutions.map(function (tagData) {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = (_c = (_b = (_a = tagData === null || tagData === void 0 ? void 0 : tagData.webSolutions) === null || _a === void 0 ? void 0 : _a.tagsAndSubCategories) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.tag, name = _h.name, slug = _h.slug, description = _h.description, colors = _h.colors, data = _h.data, assetsMap = _h.assetsMap;
        //todo: validate teaser
        return {
            name: name,
            description: description,
            color: (colors && colors[0]) || '',
            icon: ((_f = (_e = (_d = assetsMap === null || assetsMap === void 0 ? void 0 : assetsMap.collectionImage) === null || _d === void 0 ? void 0 : _d.assets) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.url) || '',
            teaser: (_g = data === null || data === void 0 ? void 0 : data.collectionDate) === null || _g === void 0 ? void 0 : _g.teaser,
            slug: slug,
        };
    });
};
export var getBadgeFromTags = function (tags, experiments) {
    if ((experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.blackFridaySale')) &&
        (tags === null || tags === void 0 ? void 0 : tags.findIndex(function (tag) { return tag.slug === 'pre-holiday-sale'; })) > -1) {
        return 'solutionBox.badge.holidaySale';
    }
    return '';
};
export var getAppBadgeTitle = function (isBundleAppInstalled, isBundleAppNotInstalled, tags, experiments, hideTagsBadge) {
    var badgeFromTags = hideTagsBadge
        ? ''
        : getBadgeFromTags(tags, experiments);
    if (badgeFromTags) {
        return badgeFromTags;
    }
    if (isBundleAppInstalled || isBundleAppNotInstalled) {
        return 'solutionBox.badge.bundle';
    }
};
export var getAppBadgeTheme = function (badgeKey) {
    if (badgeKey === 'solutionBox.badge.bundle') {
        return {
            skin: 'success',
            type: 'solid',
            size: 'small',
            uppercase: false,
        };
    }
    if (badgeKey === 'solutionBox.badge.holidaySale') {
        return {
            type: 'solid',
            size: 'small',
            uppercase: true,
        };
    }
};
export var getAppBadgeTooltipContent = function (isBundleAppInstalled, isBundleAppNotInstalled, isVoucherApp, showSaleToolTip) {
    if (showSaleToolTip) {
        return 'solutionBox.badge.sale-tooltip';
    }
    if (isBundleAppNotInstalled && isVoucherApp) {
        return 'solutionBox.badge.bundle-tooltip-voucher-not-installed';
    }
    if (isBundleAppNotInstalled) {
        return 'solutionBox.badge.bundle-tooltip-bundle-not-installed';
    }
    if (isBundleAppInstalled && isVoucherApp) {
        return 'solutionBox.badge.bundle-tooltip-installed-voucher';
    }
    if (isBundleAppInstalled) {
        return 'solutionBox.badge.bundle-tooltip-not-installed';
    }
};
//# sourceMappingURL=index.js.map